import Vue from 'vue'
import {
  Divider,
  Select,
  Option,
  Skeleton,
  SkeletonItem,
  Message,
  Badge,
  Input,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane,
  Row,
  Col,
  Pagination,
  Button,
  Popover,
  Image,
  Menu,
  MenuItem,
  Submenu
} from 'element-ui';

Vue.use(Divider)
Vue.use(Select)
Vue.use(Option)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Badge)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Row);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Popover);
Vue.use(Image);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);

Vue.prototype.$message = Message
